<template>
	<div class="app-body">
		<div class="a-flex-rsbc a-ptb-6">
			<span class="a-fs-16 a-fw-b">站点管理</span>
			<div class="a-flex-rcc">
				<el-button icon="el-icon-upload2"  @click="exportfile">导出</el-button>
				<el-button icon="el-icon-plus" type="primary"  @click="handlerAddStation" v-if="$_has(7)">站点</el-button>
				<el-button type="primary"  @click="handlerSetOverPowerAll">设置全部站点过载功率</el-button>
			</div>

		</div>


		<el-card class="el-main">
			<le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="true" id="leSearch">
				<!-- <le-input-icon-search label="站点名称" v-model="pageParam.params.searchKey"  placeholder="请输入站点名称" /> -->
				<le-input-icon-search label="站点ID" v-model="pageParam.params.stationId" placeholder="请输入站点ID" />
                <le-select-remote-search
                    label="站点"
                    reserveKeyword 
                    selectAll 
                    multiple 
                    collapse
                    v-model="pageParam.params.stationIds" 
                    :options="optionsStation" 
                    placeholder="请选择站点（可输入搜索）" />
				<le-select-local-search label="收益类型" v-model="pageParam.params.isSearchAgency"
					:options="stationTypeOptions" />
                <le-select-local-search label="站点类型" v-model="pageParam.params.stationType"
					:options="stationTypeDic" />
				<le-select-local-search label="站点状态" v-model="pageParam.params.status"
					:options="stationStatusOptions" />
				<le-input-district-choose label="所在地区" :province.sync="pageParam.params.provinceCode"
					:city.sync="pageParam.params.cityCode"
					:area.sync="pageParam.params.districtCode"></le-input-district-choose>
				<le-company-under-select label="所属商户" v-model="pageParam.params.searchCompanyId"></le-company-under-select>
                <le-select-local-search label="关联项目" v-model="pageParam.params.joinIncome" :clearable='false'
					:options="yesOrNoDic" />
                <le-select-remote-search label="站点标签" v-model="pageParam.params.tagId" :options="optionsStationlabel" placeholder="请选择标签(可搜索)" />
                <le-input-num-range label="过载功率" :minData.sync="pageParam.params.overloadPowerMin" :maxData.sync="pageParam.params.overloadPowerMax" placeholder="过载功率范围" />
                <le-select-remote-search label="电表号" v-model="ammeterId" :defaultOptions='defaultAmmeterOptions' :options="optionsAmmeter" placeholder="请选择电表(可搜索)" />
			</le-search-form>

			<le-pagview ref="stationlist" @setData="setTableData" :pageParam="pageParam" :pagerCount="5" :isFixed="true" :tableRef="$refs.stationlistTable">
				<template slot="headerLabel" slot-scope="scope" >
                    <div class="a-flex-rfsc">
                        <el-button size='mini' type="primary" @click="handleConfirmAll">批量设置过载功率</el-button>
                        <el-button size='mini' type="primary" plain @click="handleDeleteCancelAll">取消批量</el-button>
                    </div>
                </template>
                <el-table 
                    ref="stationlistTable" 
                    :data="tableData" 
                    :highlight-current-row="true" 
                    :row-key="getRowKey"
                    @selection-change="handleSelectionChange"
                    v-sticky="{ top: 0, parent:'.el-card__body' }">
					<el-table-column type="selection" fixed="left" align="center" width="55" reserve-selection  class="device-checkBox"></el-table-column>
                    <el-table-column prop="id" label="站点ID" min-width="100" >
					</el-table-column>
                    <el-table-column prop="name" label="站点名称" min-width="150" >
					</el-table-column>
					<el-table-column prop="address" label="地址" min-width="150" >
					</el-table-column>
					<el-table-column prop="statusText" label="站点状态" min-width="100">
					</el-table-column>
                    <el-table-column prop="statusText" label="站点类型" min-width="100">
                        <template slot-scope="{ row }">
                            <span>{{ row.stationType | initDic(stationTypeDic) }}</span>
                        </template>
					</el-table-column>
					<el-table-column prop="detailedStateText" label="详细状态" min-width="100">
					</el-table-column>
					<el-table-column prop="applyDate" label="建站日期" min-width="120">
					</el-table-column>
					<el-table-column prop="onlineDeviceNum" label="在线设备数" min-width="140">
                        <template slot="header">
                            <div class="a-flex-cfsfs">
                                <span>在线设备数</span>
                                <span class="a-fs-12 a-c-999">充电设备/全部设备</span>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>{{ row.onlineChargeDeviceNum || 0 }}/{{ row.onlineDeviceNum || 0 }}</span>
                        </template>
					</el-table-column>
					<el-table-column prop="totalDeviceNum" label="设备总数" min-width="140">
                        <template slot="header">
                            <div class="a-flex-cfsfs">
                                <span>设备总数</span>
                                <span class="a-fs-12 a-c-999">充电设备/全部设备</span>
                            </div>
                        </template>
                        <template slot-scope="{ row }">
                            <span>{{ row.totalChargeDeviceNum || 0 }}/{{ row.totalDeviceNum || 0 }}</span>
                        </template>
					</el-table-column>
					<!-- <el-table-column prop="usingDeviceNum" label="使用中" min-width="100">
					</el-table-column> -->
					<el-table-column prop="usingDeviceSlotNum" label="使用中(插槽)" min-width="100">
					</el-table-column>
                    <el-table-column prop="patrolNumMonth" label="本月巡检" min-width="100">
                        <template slot-scope="{ row }">
							<span :class="!row.patrolNumMonth ? 'a-c-error' : ''">{{ row.patrolNumMonth || '0' }}次</span>
						</template>
					</el-table-column>
                    <el-table-column prop="usingDeviceSlotNum" label="距离上次巡检" min-width="100">
                        <template slot-scope="{ row }">
                            <span v-if="!row.lastPatrolTime">-</span>
                            <span v-else-if="!$getDay.enumerateDaysBetweenDates(row.lastPatrolTime,$getDay.getToday()).length">1天</span>
                            <span v-else>{{ $getDay.enumerateDaysBetweenDates(row.lastPatrolTime,$getDay.getToday()).length - 1 }}天</span>
						</template>
					</el-table-column>
                    <el-table-column prop="projectId" label="电表号" min-width="150">
                        <template slot-scope="{ row }">
                            <el-popover
                                placement="top-start"
                                title="电表号"
                                width="400"
                                trigger="hover">
                                <div class="a-flex-cfsfs">
                                    <span class="a-fs-13 a-mt-10" v-for="(item,index) in row.ammeterNumbers" :key="index">{{ index+1 }}. {{ item }}</span>
                                </div>
                                <div slot="reference" class="textOver1" style="width: 140px;display: block !important">{{ row.ammeterNumbersText || '-' }}</div>
                            </el-popover>
                        </template>
                    </el-table-column>
					<!-- <el-table-column label="今日营业额" min-width="100">
						<template slot-scope="{ row }">
							<span>{{  util.numFormat(row.todayOrderAmount)  }}元</span>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="todayOrderNum" label="今日订单量" min-width="100">
					</el-table-column>
					<el-table-column label="昨日营业额" min-width="100">
						<template slot-scope="{ row }">
							<span>{{  util.numFormat(row.yesterdayOrderAmount)  }}元</span>
						</template>
					</el-table-column>
					<el-table-column prop="yesterdayOrderNum" label="昨日订单量" min-width="100">
					</el-table-column> -->
					<el-table-column label="操作" width="80" fixed="right">
						<template slot-scope="{ row }">
							<div class="a-flex-rcc">
								<el-tooltip class="item" effect="dark" content="站点详细" placement="top">
									<div @click="handlerGoDetail(row)">
										<img src="../../assets/icon/option-detail.png" class="a-wh-16" />
									</div>
								</el-tooltip>
                                <el-tooltip class="item" effect="dark" content="编辑站点" placement="top">
									<div @click="handlerEditStation(row)" v-if="(userInfo.dataPermission == 99 || userInfo.dataPermission == 88) && $_has(7)">
										<img src="../../assets/icon/option-edit.png" class="a-wh-16 a-ml-16" />
									</div>
								</el-tooltip>
							</div>

						</template>
					</el-table-column>
				</el-table>
                <template slot="footerContent" slot-scope="scope" >
                    <div class="a-flex-rfsc">
                        <div class="a-flex-rfsc" style="margin-right: 20px">
                            <span class="a-fs-12 a-c-normal">站点数：</span>
                            <span class="a-fs-14 a-c-master a-fw-b">{{ scope.val.stationNum || 0 }}</span>
                        </div>
                        <div class="a-flex-rfsc" style="margin-right: 20px">
                            <span class="a-fs-12 a-c-normal">设备数：</span>
                            <span class="a-fs-14 a-c-master a-fw-b">{{ scope.val.deviceNum || 0 }}</span>
                            <el-popover
                                placement="top"
                                width="200"
                                trigger="click">
                                <p>充电设备数：{{ scope.val.chargeDeviceNum || 0 }}</p>
                                <p>其他设备数：{{ (scope.val.deviceNum || 0) - (scope.val.chargeDeviceNum || 0) }}</p>
                                <el-button class="a-ml-5" type="text" size='mini' slot="reference">明细</el-button>
                            </el-popover>
                        </div>
                        <div class="a-flex-rfsc">
                            <span class="a-fs-12 a-c-normal">插口数：</span>
                            <span class="a-fs-14 a-c-master a-fw-b">{{ scope.val.slotNum || 0 }}</span>
                        </div>
                    </div>
                </template>
			</le-pagview>
		</el-card>
        <station-detail-setting-edit :stationIdList='stationIdList' :setAll='isSetAllOverPower' :setAllParams='pageParam.params' :visible.sync="editVisible" @changeSetting='changeSettingSuccess'></station-detail-setting-edit>
	</div>
</template>

<script>
import util from "../../utils/util.js";
import { mapState } from 'vuex';
import StationDetailSettingEdit from './station-detail-setting-edit.vue'
export default {
	mounted() { },
    components: {
        StationDetailSettingEdit
    },
	data() {
		return {
			util: util,

			stationTypeOptions: [{
				value: "0",
				label: "自营",
			},
			{
				value: "1",
				label: "参与收益",
			},
			{
				value: "2",
				label: "全部",
			},
			],
			stationStatusOptions: [{
				value: "2",
				label: "运营中",
			},
			{
				value: "0",
				label: "申报中",
			},
			{
				value: "1",
				label: "建设中",
			},
			{
				value: "3",
				label: "已撤站",
			},
			],
			activeTab: "2",

			tableData: [],
			pageParam: {
				url: this.$Config.apiUrl.getStationPage,
				method: "post",
				params: {
					searchKey: "",
                    stationIds: [],//站点ID
                    stationId: '',
					status: "",
					isSearchAgency: '2',
					searchCompanyId:'',
					districtCode:'',
					cityCode:'',
					provinceCode:'',
                    joinIncome: '0',
                    tagId: '',
                    stationType: '',
                    overloadPowerMin: '',
                    overloadPowerMax: '',
                    ammeterId: '',
                    existAmmeter: null
				},
				freshCtrl: 1,
			},
            optionsStationlabel: {
                url: this.$Config.apiUrl.getStationTagList, //getIncomeStatInfoList
                method: "post",
                params: {
                    searchKey: "",
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
            },
            optionsStation: {
                url: this.$Config.apiUrl.getStationList,
                method: "post",
                params: {},
                showLoading: false,
                labelKey: "name",
                valueKey: "stationId",
                searchKey: "name",  //incomeDistriId
                pageSize: 200
            },//站点数据
            optionsAmmeter: {
                url: this.$Config.apiUrl.ammeterFilter,
                method: "post",
                params: {},
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
                pageSize: 100
            },
            defaultAmmeterOptions: [
                {
                    name: '未配置电表',
                    id: 'notAmmeterStation'
                }
            ],
            yesOrNoDic: [],
            stationTypeDic: [],
            selectData: [],
            editVisible: false,
            isSetAllOverPower: false, //是否设置搜索范围内所有站点过载功率
            ammeterId: ''
		};
	},
	mounted() { 
        this.$getDic('yesOrNo','select').then(res=>{ this.yesOrNoDic = res; })
        this.$getDic('stationType','select').then(res=>{ this.stationTypeDic = res; })
    },
	activated () {
        if(this.$route.query.labelId){
            this.pageParam.params.tagId = Number(this.$route.query.labelId)
        }
		this.pageParam.freshCtrl++;
	},
    computed:{
        ...mapState({
            userInfo: state => state.user.user,
        }),
        stationIdList () {
            if(this.selectData.length) {
                return this.selectData.map(item=>{
                    return item.id
                })
            }else {
                return []
            }
        }
    },
	methods: {
		//获取车辆列表
		setTableData(data) {
			this.tableData = data.map(item=>{
                return {
                    ...item,
                    ammeterNumbersText: item.ammeterNumbers.join('，')
                }
            });
		},

		handlerRest() {
			this.pageParam.params = {
				searchKey: "",
                stationIds: [],//站点ID
                stationId: '',
                status: "",
                isSearchAgency: '2',
                searchCompanyId:'',
                districtCode:'',
                cityCode:'',
                provinceCode:'',
                joinIncome: '0',
                tagId: '',
                overloadPowerMin: '',
                overloadPowerMax: '',
                ammeterId: '',
                existAmmeter: null
			}
            this.ammeterId = ''
            this.handlerSearch()
		},

		handlerSearch() {
			this.$refs['stationlist'].pageNum = 1
            if(this.ammeterId == 'notAmmeterStation') {
                this.pageParam.params.existAmmeter = 0
                this.pageParam.params.ammeterId = ''
            }else {
                this.pageParam.params.existAmmeter = null
                this.pageParam.params.ammeterId = this.ammeterId
            }
			this.pageParam.freshCtrl++
		},

		handlerAddStation() {
			this.$router.push({
				path: '/station/station-add'
			})
		},

        handlerSetOverPowerAll () {
            this.isSetAllOverPower = true
            this.editVisible = true
        },

		handlerGoDetail(item) {
			if (item.status == 0) {
				this.$router.push({
					path: '/station/station-apply',
					query: {
						stationId: item.id
					}
				})
			}else{
				this.$router.push({
					path: '/station/station-detail',
					query: {
						stationId: item.id
					}
				})
			}
		},
        handlerEditStation (item) {
            this.$router.push({
                path: '/station/station-add',
                query:{
                    stationId: item.id
                }
            })
        },
        getRowKey (row) {
            return row.id
        },
        handleSelectionChange (selection) {
            this.selectData = selection
        },
        handleDeleteCancelAll () {
            this.$refs['stationlistTable'].clearSelection()
            this.selectData = []
        },
        handleConfirmAll () {
            if(!this.selectData.length) {
                this.$message.warning('请至少选择一个站点')
                return
            }
            this.isSetAllOverPower = false
            this.editVisible = true
        },
        changeSettingSuccess () {
            this.$refs['stationlistTable'].clearSelection()
            this.selectData = []
        },
        exportfile () {
            this.$exfile({
                code: 26,
                fileName: '站点列表',
                params: {
                    ...this.pageParam.params,
                }
            })
        },
	}
}
</script>

<style scoped lang="scss">
	/deep/ .el-table__body-wrapper::-webkit-scrollbar {
		/*width: 0;宽度为0隐藏*/
		width: 0 !important;
		height: 0 !important;
	}
	/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
		height: 100% !important;
	}
    /deep/ .s-search-label {
        width: 92px !important;
    }
</style>
